<article class="visit-rules">
  <header mat-dialog-title class="dialog-form__title">
    <div class="dialog-form__close">
      <a mat-dialog-close>
        <mat-icon>close</mat-icon>
      </a>
    </div>
    <h2>Visit Rules</h2>
  </header>
  <lib-card class="procedure-table" [hideTitle]="true">
    <div class="tableContainer">
      <table mat-table class="table mat-elevation-z2" [dataSource]="dataSource">
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element" id="typeName{{ i }}">
            {{ element?.typeName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="subtype">
          <th mat-header-cell *matHeaderCellDef>Subtype</th>
          <td mat-cell *matCellDef="let element" id="subtypeName{{ i }}">
            {{ element?.subtypeName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="criteria">
          <th mat-header-cell *matHeaderCellDef>Criteria</th>
          <td mat-cell *matCellDef="let element" id="criteriaString{{ i }}">
            {{ element?.criteriaString }}
          </td>
        </ng-container>
        <ng-container matColumnDef="result">
          <th mat-header-cell *matHeaderCellDef>Result</th>
          <td mat-cell *matCellDef="let element" id="result{{ i }}">
            {{ element?.result }}
          </td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Description</th>
          <td mat-cell *matCellDef="let element" id="description{{ i }}">
            {{ element?.description }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </lib-card>
</article>
